import React, { useState, useEffect } from "react"
import { Table } from "react-bootstrap"

import { getObjectsList } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"
import PageLoadingPanel from "../../shared_components/widgets/PageLoadingPanel"

export default function UserRequestTable({ intl }) {
  const [userRequest, setUserRequest] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    getObjectsList("/users/user-request/")
      .then((userRequest) => {
        setUserRequest(userRequest)
        setIsLoading(false)
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        setError(true)
        setIsLoading(false)
      })
  }, [])

  return (
    <div style={{ marginTop: "20px" }}>
      <hr />
      {isLoading ? (
        <PageLoadingPanel />
      ) : (
        <>
          {error ? (
            <p className={"error-message"}>
              {intl.formatMessage({
                id: "general.server.error",
                defaultMessage: "Error! Could not process request",
              })}
            </p>
          ) : (
            <Table className={"fixedHeadTable table table-hover"}>
              <thead>
                <tr>
                  <th>{intl.formatMessage({ id: "general.actor", defaultMessage: "Actor" })}</th>
                  <th>{intl.formatMessage({ id: "general.description", defaultMessage: "Description" })}</th>
                  <th>
                    {intl.formatMessage({
                      id: "general.request.form.urgency",
                      defaultMessage: "Urgency Level",
                    })}
                  </th>
                  <th>{intl.formatMessage({ id: "general.created.on", defaultMessage: "Created On" })}</th>
                </tr>
              </thead>
              <tbody>
                {userRequest.map((item, index) => (
                  <tr key={index}>
                    <td>{item.actor}</td>
                    <td>
                      <div style={{ maxHeight: "100px", overflowY: "auto" }}>{item.description}</div>
                    </td>
                    <td>{item.urgency}</td>
                    <td>{item.created_on}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </>
      )}
    </div>
  )
}
